import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const StagingMoveAssetRoute: Route = {
  path: 'staging/move-asset',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/move-asset.component').then((m) => m.StagingMoveAssettComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
